import { createReducer } from "@reduxjs/toolkit";
import { ScenariosStateInterface } from "../actions/Scenarios/types";
import {
    clearSelectedScenario,
    getScenarios,
    scenarioSelected,
    scenariosReceived,
    setDefaultScenarios,
    setHistoricalSelectedScenario
} from "actions";
import { resetStateRTK } from "components/curb/ManagerAnalyzer/Toggle/commonUtilities";

export const initialState: ScenariosStateInterface = {
    scenarios: null,
    selectedScenario: null,
    defaultScenarios: null,
    historicalSelectedScenario: null,
    isFetchingScenarios: true
};

const Scenarios = createReducer(initialState, (builder) => {
    builder
        .addCase(scenariosReceived, (state, action) => {
            state.scenarios = action.payload.data;
            state.isFetchingScenarios = false;
        })
        .addCase(scenarioSelected, (state, action) => {
            state.selectedScenario = action.payload.selectedScenario;
        })
        .addCase(setDefaultScenarios, (state, action) => {
            state.defaultScenarios = action.payload.defaultScenarios;
        })
        .addCase(setHistoricalSelectedScenario, (state, action) => {
            state.historicalSelectedScenario = action.payload.selectedScenario;
        })
        .addCase(clearSelectedScenario, (state) => {
            state.selectedScenario = null;
        })
        .addCase(getScenarios, (state) => {
            state.isFetchingScenarios = true;
        })
        .addCase(resetStateRTK, () => initialState)
        .addDefaultCase((state) => state);
});

export default Scenarios;
